<div class="modal-header">
  <h4 class="modal-title">
    <i data-feather="plus"></i> Sertfika oluştur
  </h4>
  <button type="button" class="close" (click)="closeModal()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="certificateForm" (ngSubmit)="onSubmit()" class="mt-2">
  <div class="modal-body">
    <div class="row">
      <div class="col-xl-3 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="disabledInput">Sertfika No</label>
          <input type="text" class="form-control" id="readonlyInput" readonly="readonly" formControlName="certificateNo"
            [value]="certificateNumber" />
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="responsiblePerson">Rezerveden Seç</label>
          <ng-select [items]="certificateReservations" bindLabel="reservedCertificateNo" bindValue="id"
            (change)="onReservationSelect($event)" (clear)="resetCertificateNumber()"></ng-select>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-12">
        <div class="form-group mb-2">
          <label for="startDate">Geçerlilik Tarihi</label>
          <ng2-flatpickr [config]="dateTimeStartOptions" formControlName="expiryDate" [setDate]="date2"></ng2-flatpickr>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-12">
        <div class="form-group mb-2">
          <label for="startDate">Yayımlanma Tarihi</label>
          <ng2-flatpickr [config]="dateTimeEndOptions" formControlName="issueDate" [setDate]="date"></ng2-flatpickr>
        </div>
      </div>

      <div class="col-xl-6 col-md-6 col-sm-12">
        <div class="form-group mb-2 custom-control custom-checkbox">
          <input type="checkbox" id="visualAndFunctional" formControlName="visualAndFunctional" class="custom-control-input">
          <label class="custom-control-label" for="visualAndFunctional">Cihaz Görsel ve Fonksiyonel Kontrolü</label>
        </div>
      </div>   
      <div class="col-xl-6 col-md-6 col-sm-12">
        <div class="form-group">
          <label for="basicInputFile">Ölçüm Dosyasını Seç (PDF)</label>
          <div class="custom-file">
            <input type="file" accept=".pdf" (change)="onFileSelected2($event)" class="custom-file-input" id="customFile" />
            <label class="custom-file-label" for="customFile">Choose file</label>
          </div>
        </div>
      </div>   
    </div>

    
    <div class="form-group">
      <button type="button" class="btn btn-outline-info" (click)="pdfDetail(false)" rippleEffect>
        <span [data-feather]="'eye'" [class]="'mr-25'"></span>Görüntüle
      </button>
      
      <button type="button" class="btn btn-outline-success" (click)="pdfDetail(true)" [disabled]="!certificateForm.valid || !pdfDoc" rippleEffect>
        <span [data-feather]="'download'" [class]="'mr-25'"></span>İndir
      </button>
    </div>
  </div>
</form>

<div id="pdf-container"></div> <!-- PDF sayfaları burada görünecek -->